import PropTypes from 'prop-types';

const scopeServiceShape = PropTypes.shape({
  isRegistered: PropTypes.func,
  register: PropTypes.func,
  getAuthorSourceScopeList: PropTypes.func,
});

export default scopeServiceShape;
